import { ReactElement, useMemo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonBatchManagementCrumbs } from '../constants';
import FormFunction, { BatchManagementForm } from 'system/components/batch-management/form';
import { useParams, useNavigate } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __OPERATION__BATCH__ } from 'shell/constants/environment';
import { Job } from 'shell/models/job-item';
import { HttpResponse } from 'shell/models/http-response';
import { transformerJob } from '../utils/transformer-job';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { useEventCallback } from '@mui/material';
import { toast } from 'react-toastify';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

const BatchManagementDetail = (): ReactElement => {
  const navigate = useNavigate();
  const params = useParams();

  const [job] = useHttpFetch<HttpResponse<Job>, BatchManagementForm>(
    `${__OPERATION__BATCH__}/jobs/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: [],
      },
      transformer: (response) => transformerJob(response, true),
    }
  );
  const startJob = useHttpClient(`${__OPERATION__BATCH__}/jobs`, { options: { method: 'POST' } });

  const startNow = useEventCallback((values: BatchManagementForm) => {
    (
      startJob({
        url: `/${values?.id}/startNow`,
      }) as ResponsePromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/gestione-batch');
    });
  });
  const content = useMemo(() => {
    return job.pristine || job.isLoading || job.hasErrors ? null : (
      <FormFunction
        title="Dettaglio Batch"
        onOk={startNow}
        onCancel={() => {
          navigate('/sistema/gestione-batch');
        }}
        disabled
        initialValues={job.data as BatchManagementForm}
      />
    );
  }, [navigate, job]);

  return (
    <>
      <Breadcrumbs items={[...CommonBatchManagementCrumbs, { name: 'Dettaglio Batch' }]} />
      {content}
    </>
  );
};

BatchManagementDetail.displayName = 'BatchManagement Detail';

export default BatchManagementDetail;
